import { EnhancedModel } from './enhanced.model';

export class User extends EnhancedModel {

    private _id:number = 0;
    public get id(): number {
        return this._id;
    } public set id(value: number) {
        this._id = value;
    }

    private _userCode: string = '';
    public get userCode(): string {
        return this._userCode;
    } public set userCode(value: string) {
        this._userCode = value;
    }

    private _name: string = '';
    public get name(): string {
        return this._name;
    } public set name(value: string) {
        this._name = value;
    }

    private _title: string = '';
    public get title(): string {
        return this._title;
    } public set title(value: string) {
        this._title = value;
    }

    private _phoneNumber: string = '';
    public get phoneNumber(): string {
        return this._phoneNumber;
    } public set phoneNumber(value: string) {
        this._phoneNumber = value;
    }

    private _phoneAreaCode: string = '';
    public get phoneAreaCode(): string {
        return this._phoneAreaCode;
    } public set phoneAreaCode(value: string) {
        this._phoneAreaCode = value;
    }

    private _phoneRegionalCode: string = '';
    public get phoneRegionalCode(): string {
        return this._phoneRegionalCode;
    } public set phoneRegionalCode(value: string) {
        this._phoneRegionalCode = value;
    }

    private _phoneCountryCode: string = '';
    public get phoneCountryCode(): string {
        return this._phoneCountryCode;
    } public set phoneCountryCode(value: string) {
        this._phoneCountryCode = value;
    }

    private _phoneExtension: string = '';
    public get phoneExtension(): string {
        return this._phoneExtension;
    } public set phoneExtension(value: string) {
        this._phoneExtension = value;
    }

    constructor(obj: any = null) {
        super();
        if (obj !== null) {
            if (obj instanceof User) {
                this.mapClone(obj);
            } else {
                this.mapJson(obj);
            }
        }
    }

    public clone(): User {
        let cloned = new User(this);
        return cloned;
    }

    protected mapClone(obj: User) {
        this.id = obj.id;
        this.userCode = obj.userCode;
        this.name = obj.name;
        this.title = obj.title;
        this.phoneNumber  = obj.phoneNumber;
        this.phoneAreaCode = obj.phoneAreaCode;
        this.phoneRegionalCode = obj.phoneRegionalCode;
        this.phoneCountryCode = obj.phoneCountryCode;
        this.phoneExtension = obj.phoneExtension;

    }

    protected mapJson(obj: any) {
        if (obj.hasOwnProperty('id')) {
            this.id = obj.id;
        }
        if (obj.hasOwnProperty('userCode')) {
            this.userCode = obj.userCode;
        }
        if (obj.hasOwnProperty('name')) {
            this.name = obj.name;
        }
        if (obj.hasOwnProperty('title')) {
            this.title = obj.title;
        }
        if (obj.hasOwnProperty('phoneNumber')) {
            this.phoneNumber = obj.phoneNumber;
        }
        if (obj.hasOwnProperty('phoneAreaCode')) {
            this.phoneAreaCode = obj.phoneAreaCode;
        }
        if (obj.hasOwnProperty('phoneRegionalCode')) {
            this.phoneRegionalCode = obj.phoneRegionalCode;
        }
        if (obj.hasOwnProperty('phoneCountryCode')) {
            this.phoneCountryCode = obj.phoneCountryCode;
        }
        if (obj.hasOwnProperty('phoneExtension')) {
            this.phoneExtension = obj.phoneExtension;
        }
        
    }
}
